export const minDob = getMinDob();
export const maxDob = getMaxDob();

function getMinDob() {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 7);
  return date;
}

function getMaxDob() {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 2);
  return date;
}
